// extracted by mini-css-extract-plugin
export default {"container":"container_container__5CA5n","grid":"container_grid__x7DTo"};